export default "__VITE_ASSET__ghYW5dah__"